import { render } from "./DisciplePage.vue?vue&type=template&id=b58a859c"
import script from "./DisciplePage.vue?vue&type=script&lang=js"
export * from "./DisciplePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__